module.exports = __webpack_public_path__ + "static/media/46.a2d6ef0e.JPG";